'use client'

import Image from 'next/image'
import { useState } from 'react'

interface ImageWithPlaceholderProps {
  src: string | null | undefined
  alt: string
  width?: number
  height?: number
  className?: string
  fill?: boolean
  priority?: boolean
  objectFit?: 'contain' | 'cover' | 'fill' | 'none' | 'scale-down'
}

export default function ImageWithPlaceholder({
  src,
  alt,
  width,
  height,
  className = '',
  fill = false,
  priority = false,
  objectFit = 'cover',
}: ImageWithPlaceholderProps) {
  const [error, setError] = useState(false)
  const placeholderPath = '/images/placeholder.svg'

  const imageSrc = error || !src ? placeholderPath : src

  if (fill) {
    return (
      <div className={`relative w-full h-full ${className}`}>
        <Image
          src={imageSrc}
          alt={alt}
          fill
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          className={`object-${objectFit}`}
          onError={() => setError(true)}
          priority={priority}
        />
      </div>
    )
  }

  return (
    <Image
      src={imageSrc}
      alt={alt}
      width={width || 800}
      height={height || 600}
      className={className}
      onError={() => setError(true)}
      priority={priority}
      unoptimized={imageSrc === placeholderPath}
    />
  )
}

